import { webApi } from "../../lib/WebApi"
import { clearToken } from "trux"

export const defaultState = {
    currentTeamId: null,
    currentTeam: null,
    divisions: [],
    user: null,
    loading: false,
    loggingInUser: false,
    loggingInTeam: false,
    isUserLoggedIn: null,
    isTeamLoggedIn: null,
    loadedTeam: false,
}

export const logout = async () => {
    await webApi._post("/webapp/users/self/logout")
}

export const logIn = async (user, userIdParam, token) => {
    console.log("login running")
    if (user && user.user_id !== userIdParam) {
        await webApi._post("/webapp/users/self/logout")
        await new Promise((r) => setTimeout(r, 2000))
        await webApi.loginByCode(userIdParam, token)
        await new Promise((r) => setTimeout(r, 2000))
    } else if (!user) {
        await webApi.loginByCode(userIdParam, token)
        await new Promise((r) => setTimeout(r, 2000))
    }
}

export const updatePlayer = async (userId, userData) => {
    try {
        let response = await webApi._post(`/webapp/users/${userId}`, userData)
        return response
    } catch (err) {
        console.error(err)
        alert(err)
    }
}

export const emailSwitch = async (
    userId,
    userData,
    relations,
    relationToAdd
) => {
    let update = await updatePlayer(userId, userData)

    let relation = await addRelation(userId, relations, relationToAdd)
    console.log("done")
}

export const getUserInfo = async () => {
    try {
        let response = await webApi._get("/webapp/users/self")
        let user = await response
        return user
        console.log("User", user)
    } catch (err) {
        alert(err)
    }
}

export function loadUser(cb = null) {
    return (dispatch) => {
        dispatch({
            type: "COMMON_SET",
            value: {
                loadingUser: true,
            },
            key: "nav",
            defaultValue: defaultState,
        })

        return webApi
            ._get("/webapp/users/self")
            .then((json) => {
                console.log("json", json)
                clearToken()
                dispatch({
                    type: "COMMON_SET",
                    value: {
                        user: json,
                        loadingUser: false,
                        isUserLoggedIn: true,
                        loadUserError: null,
                    },
                    key: "nav",
                    defaultValue: defaultState,
                })

                if (cb) {
                    cb(json)
                }
            })
            .catch((err) => {
                clearToken()
                console.log("error", err)
                dispatch({
                    type: "COMMON_SET",
                    value: {
                        user: null,
                        loadingUser: false,
                        isUserLoggedIn: false,
                        loadUserError: err,
                    },
                    key: "nav",
                    defaultValue: defaultState,
                })

                if (cb) {
                    cb(null)
                }
            })
    }
}

export const checkForEmail = async (email) => {
    try {
        let response = await webApi._post("/webapp/users/search/by-email", {
            email,
        })
        console.log("response", response)
        return response
    } catch {
        console.log("no email")
        return null
    }
}

export const addPlayerRelation = async (userId, relation) => {
    try {
        let response = webApi._post(
            `/webapp/users/${userId}/relations/create`,
            relation
        )
        return response
    } catch (err) {
        alert(err)
    }
}

export const addRelation = async (userId, relations, relationToAdd) => {
    let emailCheck = await checkForEmail(relationToAdd.email)
    console.log("email check", emailCheck)
    let match = false

    if (emailCheck) {
        for (let relation of relations) {
            if (relation.user.email === relationToAdd.email) {
                match = true
                console.log("matching email")
            }
        }
    }

    if (!match) {
        addPlayerRelation(userId, {
            first_name: relationToAdd.first_name,
            email: relationToAdd.email,
            relation_type: "child",
        })
    }
}

export function removePlayerRelation(userId, relation) {
    return new Promise((resolve, reject) => {
        webApi
            ._post(
                `/webapp/user-relations/${relation.user_relationship_id}/delete`,
                {}
            )
            .then((data) => {
                resolve()
            })
            .catch((err) => {
                resolve()
            })
    })
}

export const loadPlayerRelations = async (userId) => {
    let response = await webApi._get(`/webapp/users/${userId}/relations`, {})

    if (response) {
        var contacts = []
        for (var i in response) {
            var c = {
                _editable: false,
                first_name: response[i].related_user.first_name,
                last_name: response[i].related_user.last_name,
                email: response[i].related_user.email,
                user_relationship_id: response[i].user_relationship_id,
            }
            contacts.push(c)
        }
    }
    return contacts
}

export function addAllRelations(userIds, relation, data) {
    console.log("add all relations", userIds, relation, data)
    return new Promise((resolve, reject) => {
        addAllPlayerRelations(userIds, relation, (success) => {
            resolve(data)
        })
    })
}

function addAllPlayerRelations(userIds, relation, cb) {
    var userId = userIds.pop()
    console.log("user id", userId)
    if (userId != null) {
        addPlayerRelation(userId, relation).then(() => {
            addAllPlayerRelations(userIds, relation, cb)
        })
    } else {
        cb(true)
    }
}

// function addPlayerRelation(userId, relation) {
//     return new Promise((resolve, reject) => {
//         delete relation['_editable']
//         webApi._post(`/webapp/users/${userId}/relations/create`, relation)
//             .then((data) => {
//                 resolve()
//             })
//             .catch((err) => {
//                 resolve()
//             })
//     })
// }

// export function addPlayerRelation(userId, relation) {
//     return new Promise((resolve, reject) => {
//         console.log(
//             "userid and relation",
//             userId,
//             relation,
//             `/webapp/users/${userId}/relations/create`
//         )
//         webApi
//             ._post(`/webapp/users/${userId}/relations/create`, relation)
//             .then((data) => {
//                 console.log("data", data)
//                 resolve()
//             })
//             .catch((err) => {
//                 console.error("err", err)
//                 resolve()
//             })
//     })
// }

// export const addPlayerRelation = async (userId, relation) {
//     try {

//     }
// }

// export function addRelation(userId, relations, email) {
//     checkForEmail(email).then((res) => {
//         let match = false
//         if (res) {
//             for (let rel of relations) {
//                 if (rel.user.email === email) {
//                     match = true
//                     console.log("matching email", rel, email)
//                 }
//             }
//         }

//         if (!match) {
//             console.log("no match, add relation")
//             addPlayerRelation(userId, {
//                 first_name: "test",
//                 email: email,
//                 relation_type: "child",
//             })
//                 .then((res) => {
//                     console.log("result", res)
//                 })
//                 .catch()
//         }
//         console.log("check for email result", res)
//     })
// }
